import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Subtitle from './Subtitle';
import NotificationItem from './NotificationItem';
import NotificationItemReports from './NotificationItemReports';


const teamTitle =<FormattedMessage id="team.notifications" defaultMessage="Team member notifications" />;
const teamDescription =<FormattedMessage id="team.notifications.desc" defaultMessage="Notify your participants through different channels" />;
const emailNotifications = <FormattedMessage id="notif.email" defaultMessage="Send notifications through Email" />;
const slackNotifications = <FormattedMessage id="notif.slack" defaultMessage="Send notifications through Slack" />;
const discordNotifications = <FormattedMessage id="notif.slack" defaultMessage="Send notifications through Discord" />;
const reportTitle =<FormattedMessage id="admin.notifications" defaultMessage="Admin notifications" />;
const reportDescription =<FormattedMessage id="report.notifications.desc" defaultMessage="Get notifications and reports on completed check-ins" />;
const reportNotifications = <FormattedMessage id="email.reports" defaultMessage="Weekly Email Reports" />;
const reportNotificationsDesc = <FormattedMessage id="email.reports.desc" defaultMessage="Get a report each Sunday, which will let you know how your check-in went" />;
const reportNotificationsInput = <FormattedMessage id="email.reports.input" defaultMessage="Report Time" />;
const frequencyNotifications = <FormattedMessage id="email.notification" defaultMessage="Email Notifications" />;
const frequencyNotificationsDesc = <FormattedMessage id="email.notification.desc" defaultMessage="Get a notification about completed Check-ins" />;
const frequencyNotificationsInput = <FormattedMessage id="email.notification.input" defaultMessage="Report Frequency" />;

const wordingUsers = {
  placeholderId: "select.members",
  placeholderMsg: "Select members",
}

const wordingSlack = {
  placeholderId: "select.channels",
  placeholderMsg: "Select channels",
}

const wordingFrequency = {
  placeholderId: "select.frequency",
  placeholderMsg: "Select frequency",
}

const wordingTime = {
  hours: {
    placeholderId: "hours",
    placeholderMsg: "Hours",
  },
  minutes: {
    placeholderId: "minutes",
    placeholderMsg: "Minutes",
  }
}

const Notifications = ({
  emailIsActive,
  formData,
  setFormData,
  emailUsersOptions,
  choosedEmailUsers,
  handleEmailUsers,
  company,
  slackIsActive,
  choosedSlackUsers,
  slackUserAndChannelOptions,
  handleSlackUsers,
  reportIsActive,
  localReportHour,
  localReportMinute,
  minuteOptions,
  hourOptions,
  handleIntervalSelect,
  reportFrequency,
  reportFrequencyOptions,
  type,
  handleSelect
}) => {
  
  return (
    <div className="pb-2">
      <div className="mb-2">
        <div className="mb-07">
          <Subtitle title={teamTitle} />
        </div>
        <p className="fs-12 lh-15 text-left">{teamDescription}</p>
      </div>

      <NotificationItem 
        checkboxName={"emailIsActive"}
        checkboxValue={emailIsActive}
        formData={formData}
        setFormData={setFormData}
        defaultValue={choosedEmailUsers}
        handleSelect={handleEmailUsers}
        selectOptions={emailUsersOptions}
        isClearable={false}
        key={`users-U`}
        wording={wordingUsers}
        isMulti={true}
        isSearchable={true}
        label={emailNotifications}
      />

      {company && company.isSlack && (
        <div className="mt-1">
          <NotificationItem 
            checkboxName={"slackIsActive"}
            checkboxValue={slackIsActive}
            formData={formData}
            setFormData={setFormData}
            defaultValue={choosedSlackUsers}
            handleSelect={handleSlackUsers}
            selectOptions={slackUserAndChannelOptions}
            isClearable={false}
            key={`slack-U`}
            wording={wordingSlack}
            isMulti={true}
            isSearchable={true}
            label={slackNotifications}
          />
        </div>
      )}

      <div className="mt-2">
        <div className="mb-07">
          <Subtitle title={reportTitle} />
        </div>
        <p className="fs-12 lh-15 text-left">{reportDescription}</p>
      </div>

      <NotificationItemReports 
        checkboxName={"isCheckinReport"}
        checkboxValue={formData.isCheckinReport}
        formData={formData}
        setFormData={setFormData}
        defaultValue={reportFrequency}
        handleSelect={handleSelect}
        selectOptions={reportFrequencyOptions}
        isClearable={false}
        key={`frequency-U`}
        wording={wordingFrequency}
        isMulti={false}
        isSearchable={true}
        label={frequencyNotifications}
        subTitle={frequencyNotificationsDesc}
        inputLabel={frequencyNotificationsInput}
        type={type}
        section={1}
        localReportTime={{hour:localReportHour, minute: localReportMinute}}
      />

      <div className="mb-2">
        <NotificationItemReports 
          checkboxName={"reportIsActive"}
          checkboxValue={reportIsActive}
          formData={formData}
          setFormData={setFormData}
          defaultValue={{hour:localReportHour, minute: localReportMinute}}
          handleSelect={handleIntervalSelect}
          selectOptions={{hour: hourOptions, minute: minuteOptions}}
          isClearable={false}
          key={`reports-U`}
          wording={wordingTime}
          isMulti={false}
          isSearchable={true}
          label={reportNotifications}
          subTitle={reportNotificationsDesc}
          inputLabel={reportNotificationsInput}
          type={type}
          section={2}
        />
      </div>

      <div className="sub-menu__page mb-4"></div>

    </div>
  );
};

Notifications.propTypes = {
  emailIsActive: PropTypes.bool,
  text: PropTypes.object,
};

export default Notifications;
